// Reusable status update functionality
// Can be used on both account and profile pages

window.StatusUpdateManager = (function() {
  'use strict';

  // Private functions
  const setLocalStatus = function() {
    $(".status-updates__tmp-message").val($(".status-updates__input").val());
  };

  const showSpinner = function() {
    $(".status-updates__save").addClass("hidden");
    $(".status-updates__clear").addClass("hidden");
    $(".status-updates__footer").addClass("hidden");
    $(".status-updates__spinner").removeClass("hidden");
  };

  const hideSpinner = function() {
    $(".status-updates__spinner").addClass("hidden");
  };

  const updateFooterVisibility = function() {
    const saveVisible = !$(".status-updates__save").hasClass("hidden");
    const clearVisible = !$(".status-updates__clear").hasClass("hidden");

    if (saveVisible || clearVisible) {
      $(".status-updates__footer").removeClass("hidden").addClass("flex");
    } else {
      $(".status-updates__footer").removeClass("flex").addClass("hidden");
    }
  };

  const autoResizeTextarea = function(textarea) {
    const element = textarea[0];
    if (!element) return;

    // Reset height to auto to get the correct scrollHeight
    element.style.height = 'auto';

    // Set height based on content, with a max of ~4 lines (96px = 24px per line * 4)
    const newHeight = Math.min(element.scrollHeight, 96);
    element.style.height = newHeight + 'px';
  };

  const updateButtonStates = function(statusInput) {
    const currentValue = statusInput.val();
    const savedValue = $(".status-updates__tmp-message").val();

    if (currentValue !== savedValue) {
      $(".status-updates__save").removeClass("hidden");
    } else {
      $(".status-updates__save").addClass("hidden");
    }

    if (currentValue === "") {
      $(".status-updates__clear").addClass("hidden");
    } else {
      $(".status-updates__clear").removeClass("hidden");
    }

    updateFooterVisibility();
  };

  // Public interface
  return {
    init: function(options = {}) {
      const statusInput = $(".status-updates__input");
      const editForm = $(".status-updates__edit-form");

      // Check if required elements exist
      if (statusInput.length === 0 || editForm.length === 0) {
        console.warn("StatusUpdateManager: Required elements not found, skipping initialization");
        return;
      }

      // Default callbacks
      const defaults = {
        onSuccess: function(response) {
          hideSpinner();
          $(".status-updates__save").addClass("hidden");
          $(".status-updates__clear").addClass("hidden");
          updateFooterVisibility();
          setLocalStatus();
          autoResizeTextarea(statusInput);
        },
        onError: function(jqXHR, textStatus, errorThrown) {
          console.error("StatusUpdateManager: Error saving status:", textStatus, errorThrown);
          hideSpinner();
          // Show save button again if status differs from saved value
          const currentInput = $(".status-updates__input");
          if (currentInput.val() !== $(".status-updates__tmp-message").val()) {
            $(".status-updates__save").removeClass("hidden");
          }
          // Show clear button if there's content
          if (currentInput.val() !== "") {
            $(".status-updates__clear").removeClass("hidden");
          }
          updateFooterVisibility();
        },
        beforeSave: function() {
          // Hook for custom actions before save
        },
        afterFormToggle: function(isEditing) {
          // Hook for custom actions when form is toggled
        },
        onEditClick: function() {
          // Default behavior - no special handling needed for account page
        }
      };

      // Merge options with defaults
      const config = Object.assign({}, defaults, options);

      // Save function
      const doSave = function(e) {
        e.preventDefault();
        setLocalStatus();
        showSpinner();
        
        config.beforeSave();
        
        const formData = editForm.serialize();

        $.ajax({
          type: "POST",
          url: editForm.attr("action"),
          data: formData,
          success: config.onSuccess,
          error: config.onError
        });
      };

      // Event handlers
      editForm.on("submit", doSave);
      $(".status-updates__save").click(() => editForm.submit());

      // Edit link click handler - using event delegation for better reliability
      $(document).on("click", ".status-updates__edit-link", function(e) {
        e.preventDefault();
        config.onEditClick();
      });

      // Clear button
      $(".status-updates__clear").click(function(e) {
        e.preventDefault();
        statusInput.val("");
        autoResizeTextarea(statusInput);
        $(".status-updates__save").addClass("hidden");
        $(".status-updates__clear").addClass("hidden");
        updateFooterVisibility();
        editForm.submit();
      });

      // Focus handler
      statusInput.focus(function() {
        setLocalStatus();
        autoResizeTextarea(statusInput);
        if (statusInput.val() !== "" || statusInput.val() !== $(".status-updates__tmp-message").val()) {
          $(".status-updates__save").removeClass("hidden");
        }
        if (statusInput.val() !== "") {
          $(".status-updates__clear").removeClass("hidden");
        }
        updateFooterVisibility();
      });

      // Keyup and input handlers
      statusInput.on('input keyup', function() {
        autoResizeTextarea(statusInput);
        updateButtonStates(statusInput);
      });

      // Initialize button states and textarea height
      if (statusInput.val() === "") {
        $(".status-updates__save").addClass("hidden");
        $(".status-updates__clear").addClass("hidden");
        $(".status-updates__footer").addClass("hidden");
      } else {
        updateFooterVisibility();
      }

      // Initialize textarea height
      autoResizeTextarea(statusInput);

      // Show edit link (for account page)
      $(".status-updates__edit-link").show();
    }
  };
})();
